module.exports = __webpack_public_path__ + "img/9788950957766.1bb52178.jpg";